import {  Breadcrumb } from 'antd';
import { userdata } from '../typing/table_typing';
import { Component } from 'react';

export interface TableThingyMainProps{
  entry:userdata,
  link:userdata,
  view:{
    loaded:boolean,
    autorefresh:boolean,
  }
  onLoadRequested:()=>void;
}

interface TableThinyViewInnerState{filteredInfo:any, sortedInfo:any,   visible: boolean[],
  condition: boolean,itemToDelete:string}

export class BreadCrumpView extends Component<TableThingyMainProps, TableThinyViewInnerState> 
{
    componentDidMount(){
     // this.props.onLoadRequested();
       setTimeout(() => {
       // setInterval(() => {
         // console.log(Date.now());
        this.props.onLoadRequested()
      }, 300);
      
      // this.props.onButtonClicked();
    }


render(){
  // Den zweiten Eintrag nur zeigen, wenn er gefuellt ist. Sonst stuende dort
  // ein Trennstrich ohne Ziel - so wie zuvor "Vodin / Side" auf jeder Seite.
  return(
  <Breadcrumb style={{ margin: '16px 0' }}>
    <Breadcrumb.Item>{this.props.entry.main}</Breadcrumb.Item>
    {this.props.entry.sub
      ? <Breadcrumb.Item>{this.props.entry.sub}</Breadcrumb.Item>
      : null}
  </Breadcrumb>
  )
}
}

export default BreadCrumpView;